<template>
  <div class="card-reply-item" @dblclick="emit('send-card', cardItem)">
    <xiaohsCardItem v-if="String(currentPlatformType) === '2'" :card-item="cardItem" />
    <div v-else class="unsupported-card">当前平台暂不支持卡片/名片</div>

    <el-button
      v-if="String(currentPlatformType) === '2'"
      class="send-button"
      size="small"
      type="success"
      @click.stop="emit('send-card', cardItem)">
      发送
    </el-button>
  </div>
</template>

<script>
import { toRefs } from "vue";
import xiaohsCardItem from "./xiaohsCardItem.vue";

export default {
  components: { xiaohsCardItem },
  props: {
    currentPlatformType: [String, Number],
    cardItem: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["send-card"],
  setup(props, { emit }) {
    return {
      ...toRefs(props),
      emit,
    };
  },
};
</script>

<style lang="scss" scoped>
.card-reply-item {
  --card-tag-primary: #e6a23c;
  --card-tag-primary-light: #f3c36b;
  --card-tag-text: #9a6a1f;
  --card-tag-bg: rgba(230, 162, 60, 0.14);
  --card-tag-border: rgba(230, 162, 60, 0.22);

  display: flex;
  align-items: center;
  gap: 10px;
  box-sizing: border-box;
  padding: 10px;
  border: 1px solid rgba(244, 114, 182, 0.16);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  transition:
    transform 0.18s ease,
    border-color 0.18s ease,
    box-shadow 0.18s ease;
}

.card-reply-item:hover {
  border-color: rgba(255, 56, 92, 0.36);
  box-shadow: 0 12px 26px rgba(244, 114, 182, 0.16);
  transform: translateY(-1px);
}

.send-button {
  flex-shrink: 0;
}

.unsupported-card {
  flex: 1;
  color: #71717a;
  font-size: 13px;
}
</style>
